import axios from 'axios'
import { isApiErrorResponse } from '@/helpers/api'

declare interface ApiViolation {
  code: string,
  message: string,
  propertyPath: string,
}

export function getErrorMessage(error: unknown): string {
  if (isApiErrorResponse(error)) {
    const apiError = error as ApiResponseError

    return apiError.errors?.length ? Object.values(apiError.errors).join(' ') : apiError.message
  }
  if (axios.isAxiosError(error)) {
    if (error.response?.data?.violations) {
      return error.response.data.violations.map((violation: ApiViolation) => violation.message).join(' ')
    }

    return error.response?.data?.message || error.message
  }
  if (error instanceof TypeError) {
    return error.message
  }
  if (error instanceof Object) {
    return error.toString()
  }

  return ''
}

export function getErrorTitle(error: unknown): string {
  if (axios.isAxiosError(error)) {
    if (error.response?.data?.violations) {
      const fields = error.response.data.violations.map((violation: ApiViolation) => violation.propertyPath).join(', ')
      return `Invalid fields: ${fields}`
    }

    return error.name
  }

  if (error instanceof TypeError) {
    return error.name
  }

  return ''
}
